<template>
    <div id="email-list">
        <div v-for="(email, index) in emailRecipients" v-bind:key="email">
            <div class="added-emails">
                <div class="added-emails__address">{{ email }}</div><button class="remove-email"
                    v-on:click="removeEmail(index)">Remove</button>
            </div>
        </div>
        <div class="add-email">
            <div class="input-group">
                <input class="form-control" v-model='$v.newEmail.$model' type="email" v-bind:placeholder="placeholder" />
                <span class="input-group-btn">
                    <button class="btn btn-default add-email-button" type="button" v-on:click="addNewEmail">Add</button>
                </span>
            </div>
        </div>
        <div class="field-validation-error"  v-if="$v.newEmail.$dirty && !$v.newEmail.email">{{emailInvalid}}</div>
        <div class="field-validation-error"  v-if="emailError">{{emailrequired}}</div>
    </div>
</template>

<script>
    import { required, email} from 'vuelidate/lib/validators'

    export default {
        name: "EmailList",

        data() {
            return {
                newEmail: '',
                emailError: false
            }
        },

        validations() {
            var validations = {};

            if (this.sendOptionsEmail == "true") {
                validations.emailRecipients = {
                    required
                };
                validations.newEmail = {
                    email
                }
            }

            return validations;
        },

        props: {
            sendOptionsEmail: String,
            emailRecipients: Array,
            placeholder: String,
            emailrequired: String,
            emailInvalid: String
        },

        methods: {
            addNewEmail: function () {
                if (!this.emailRecipients.includes(this.newEmail) && this.$v.newEmail.email && this.newEmail != '') {
                    this.emailRecipients.push(this.newEmail)
                    this.newEmail = '';
                    // this.$v.reset();
                }
                this.emailError = !this.$v.emailRecipients.required;
            },
            removeEmail(index) {
                this.emailRecipients.splice(index, 1)
                this.emailError = !this.$v.emailRecipients.required;
            }
        }
    };
</script>